namespace('compass.account');

compass.require('compass.hotel.StayRecapWidget');
compass.require('compass.hotel.EPSStayRecapWidget');

compass.account.FullFolioWidget = compass.defineWidget(function FullFolioWidget(options) {
	var me = this;
	var d = jQuery.dom.getContext(this);

	/* accessibilty structure */
	var accessibilty = {
		TAB_INDEX: 0
	};

	var $j = jQuery;
	var _settings = options;
	var recapArray = _settings.recapArray;
	var epsRecapArray = recapArray[0].stayRecap.epsRecap;
	var totals = _settings.totals;

	var _render = this.render = function(widgetElem) {
		var recapDiv = d.div({className:'folioStayRecapDiv'});

		if (recapArray[0].stayRecap.EPS === true) {
			_stayRecapWidget = new compass.hotel.EPSStayRecapWidget(recapDiv, {
				header: {
					hotelThumbnail: recapArray[0].stayRecap.hotelThumbnail,
					hotelName: recapArray[0].stayRecap.hotelName,
					roomType: recapArray[0].stayRecap.roomName,
					bedType: recapArray[0].stayRecap.bedType,
					bedRequest: recapArray[0].stayRecap.isBedTypeRequest ? 2 : recapArray[0].stayRecap.bedRequest,
					avgRate: recapArray[0].stayRecap.avgRate
				},
				meetingInfo: _settings.meetingInfo,
				recap: epsRecapArray,
				merchantOfRecord: _settings.merchantOfRecord,
				depositInfo: _settings.depositInfo
			});
		} else {
			_stayRecapWidget = new compass.hotel.StayRecapWidget(recapDiv, {
				WUID : 'stayRecapWidget_individualPersonalInfo',
				recapArray : recapArray,
				meetingInfo: _settings.meetingInfo,
				hasGIN: options.hasGIN,
				chargingInfo: _settings.chargingInfo,
				alwaysShowAmountCharged: true,
				outstandingDeposit : _settings.outstandingDeposit,
				depositWillBeChargedTodayOrEarlier : _settings.depositWillBeChargedTodayOrEarlier,
				depositWillBeChargedAt : _settings.depositWillBeChargedAt,
				paymentInfo : _settings.paymentInfo
			});
		}
		var viewConfoButton = d.button({className:'button viewConfirmationButton', 'aria-role':'link', tabindex: 0}, 'View Confirmation');
		viewConfoButton.activate(function(){	
			compass.loading.start($j('.viewConfirmationButton').empty(), { color : '#FFFFFF' });
			me.trigger(CompassEvents.ShowConfirmation);
		});

		if (!_settings.meetingInfo.canSendConfo) {
			viewConfoButton = {};
		} 

		var folioDiv = d.div({className:'FullFolioDiv'});
		folioDiv.append(d.div({className:'folioHeaderDiv'}, 'Hotel Folio'),
						d.h4(d.reader('Reservation Summary')),
						recapDiv,
						viewConfoButton,
						d.div({'className':'floatClear'})
		);
		
		widgetElem.append(folioDiv);
	};
	
}, {
	WUID: "crap",
	widgetName: 'FullFolioWidget',
	
	account: {}
});
